import { render } from "./ObjectBuilderIndex.vue?vue&type=template&id=04d64040"
import script from "./ObjectBuilderIndex.vue?vue&type=script&lang=js"
export * from "./ObjectBuilderIndex.vue?vue&type=script&lang=js"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QFile,QIcon,QTable,QTd,QTooltip});
